import { render, staticRenderFns } from "./personnelWage.vue?vue&type=template&id=d4d9e26e&scoped=true"
import script from "./personnelWage.vue?vue&type=script&lang=js"
export * from "./personnelWage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d9e26e",
  null
  
)

export default component.exports